"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("@iov/encoding");
const ripemd160_1 = __importDefault(require("ripemd160"));
const { toHex } = encoding_1.Encoding;
class Ripemd160 {
    constructor(firstData) {
        this.blockSize = 512 / 8;
        this.impl = new ripemd160_1.default();
        if (firstData) {
            this.update(firstData);
        }
    }
    update(data) {
        this.impl.update(toHex(data), "hex");
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
exports.Ripemd160 = Ripemd160;
//# sourceMappingURL=ripemd.js.map